// レビュー概算数
export const REVIEW_COUNT = 17000;
